import { useApi } from "@platform/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deactivateCarrierRep } from "../api/client";

import { CARRIERS_QUERY_KEY } from "./useCarriersQuery";

import type { UseMutationResult } from "@tanstack/react-query";

export const useDeactivateCarrierRepMutation = (
  carrierId: number,
): UseMutationResult<void, Error, number> => {
  const axiosInstance = useApi();
  const queryClient = useQueryClient();

  return useMutation<void, Error, number>({
    mutationFn: (carrierRepId) =>
      deactivateCarrierRep(axiosInstance, carrierId, carrierRepId),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: CARRIERS_QUERY_KEY }),
  });
};
